module.exports = __webpack_public_path__ + "static/media/icon-piece3-2.b4c2d3df.png";